import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { UserService } from 'app/shared/services/user.service';
import { SharedService } from 'app/shared/services/shared.service';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class FeatureGuard implements CanActivate {
  public subscriptions: Array<any>;

  constructor(public router: Router, public userService: UserService, public sharedService: SharedService) {
    this.subscriptions = [];
  }

  canActivate(next: ActivatedRouteSnapshot): Observable<boolean> | boolean {
    return this.isConfigurationLoaded(next);
  }

  getAnswer(featureFlag: string = '', answer: boolean): any {
    if (featureFlag) {
      answer = this.userService.getFeatureState(featureFlag);
      if (!answer) {
        this.router.navigate(['/']);
      }
      return answer;
    }
    return false;
  }

  isConfigurationLoaded(next: ActivatedRouteSnapshot): Observable<any> {
    const featureFlag: string = next.data['featureFlag'];
    const answer = false;

    if (this.userService.networkData) {
      return this.getAnswer(featureFlag, answer);
    } else {
      this.subscriptions.push(
        this.sharedService.getMessagesBus().subscribe((response: any) => {
          if (response.type === 'CONFIGURATION_LOADED') {
            if (this.getAnswer(featureFlag, answer)) {
              this.router.navigate([next.routeConfig.path]);
            } else {
              this.router.navigate(['/']);
            }
          }
        })
      );
    }
  }
}
